import React, { useState } from 'react';
import './Auth.css';
import './PostSignup.css';
import { API_ENDPOINTS } from '../config/apiConfig';
import { apiService } from '../services/api';
import BrandLogo from '../assets/images/big-atom-logo copy.png';
import MetaLogo from '../assets/images/meta-logo.svg';
import FacebookLogo from '../assets/icons/Facebook Logo.svg';

const PostSignup = () => {
  const [isConnecting, setIsConnecting] = useState(false);
  const [connectError, setConnectError] = useState(null);

  const resolveOrgId = () => {
    const storedProfile = localStorage.getItem('user_profile');
    if (storedProfile) {
      try {
        const parsedProfile = JSON.parse(storedProfile);
        if (parsedProfile && parsedProfile.orgId !== undefined && parsedProfile.orgId !== null) {
          return parsedProfile.orgId;
        }
      } catch (err) {
        console.warn('Unable to parse user profile from storage:', err);
      }
    }

    const legacyOrgId = localStorage.getItem('orgId');
    if (legacyOrgId) {
      return legacyOrgId;
    }

    return null;
  };

  const handleMetaConnect = async () => {
    if (isConnecting) return;

    const orgId = resolveOrgId();

    try {
      setConnectError(null);
      setIsConnecting(true);

      if (!orgId) {
        setConnectError('No organization is associated with this account. Please sign in again or contact support.');
        setIsConnecting(false);
        return;
      }

      const response = await apiService.get(
        API_ENDPOINTS.META_OAUTH_START(orgId),
        {
          // Allow caller to inspect non-200 responses
          validateStatus: (status) => status >= 200 && status < 400,
        }
      );

      const redirectUrl =
        (response && typeof response === 'string' && response) ||
        response?.redirectUrl ||
        response?.authorizeUrl ||
        response?.url ||
        response?.location ||
        null;

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        console.warn('Meta OAuth start did not return a redirect URL', response);
        setConnectError('Unable to start Meta connection. Please try again later.');
      }
    } catch (error) {
      console.error('Failed to initiate Meta OAuth:', error);
      const fallbackMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Unable to start Meta connection. Please try again.';
      setConnectError(fallbackMessage);
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <div className="auth-layout post-signup-layout">
      <aside className="auth-brand post-signup-brand">
        <div className="auth-brand-content">
          <img src={BrandLogo} alt="Big Atom" className="post-signup-brand-logo" />
          <h1 className="auth-brand-title">Complete Your Big Atom Setup</h1>
          <p className="auth-brand-subtitle">
            Link your Meta assets so Big Atom can continuously monitor signal quality, map diagnostics,
            and alert your team before conversions drop.
          </p>
          <ul className="auth-usp-list">
            <li>Maintain accurate web & offline event coverage</li>
            <li>Unlock diagnostics and automated alerting</li>
            <li>Optimize campaigns with richer, real-time data</li>
          </ul>
        </div>
      </aside>

      <main className="auth-panel">
          {connectError && (
            <div className="auth-error">
              <span>⚠️</span>
              <span>{connectError}</span>
            </div>
          )}

          <button
            type="button"
            className="meta-connect-button facebook-button"
            onClick={handleMetaConnect}
            disabled={isConnecting}
          >
            <div className="facebook-icon-wrapper">
              <img src={FacebookLogo} alt="Facebook" className="facebook-logo-icon" />
            </div>
            <span>{isConnecting ? 'Connecting to Facebook…' : 'Continue with Facebook'}</span>
          </button>
        
      </main>
    </div>
  );
};

export default PostSignup;
